import React, { useState } from "react";
import {
  Dialog,
  DialogContent,
  DialogHeader,
  DialogTitle,
  DialogFooter,
} from "@/components/ui/dialog";
import { Button } from "@/components/ui/button";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";

export default function CreateLeadDialog({ open, onClose, onSubmit, isLoading, defaultEmbudo = "recibidos" }) {
  const [formData, setFormData] = useState({
    nombre: "",
    empresa: "",
    email: "",
    telefono: "",
    notas_internas: "",
    origen: "manual",
    estado: "nuevo",
    embudo: defaultEmbudo,
    // Arranca como pendiente de respuesta para que aparezca el indicador en
    // el Kanban hasta que alguien le conteste. shouldShowPendienteEmail trata
    // undefined como false, así que el campo tiene que estar explícito.
    pendiente_email: true,
    historial_estados: [],
    comentarios: []
  });

  const handleSubmit = (e) => {
    e.preventDefault();
    const dataToSend = {
      ...formData,
      historial_estados: [{
        estado: "nuevo",
        fecha: new Date().toISOString(),
        usuario: "Usuario"
      }]
    };
    onSubmit(dataToSend);
    setFormData({
      nombre: "",
      empresa: "",
      email: "",
      telefono: "",
      notas_internas: "",
      origen: "manual",
      estado: "nuevo",
      embudo: defaultEmbudo,
      historial_estados: [],
      comentarios: []
    });
  };

  return (
    <Dialog open={open} onOpenChange={onClose}>
      <DialogContent className="sm:max-w-xl dark:bg-gray-900">
        <DialogHeader>
          <DialogTitle className="text-2xl text-gray-900 dark:text-white">Crear Nuevo Lead</DialogTitle>
        </DialogHeader>
        
        <form onSubmit={handleSubmit}>
          <div className="space-y-4 py-4">
            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label htmlFor="nombre" className="dark:text-gray-300">Nombre *</Label>
                <Input
                  id="nombre"
                  value={formData.nombre}
                  onChange={(e) => setFormData({...formData, nombre: e.target.value})}
                  required
                  className="dark:bg-gray-800 dark:border-gray-700"
                />
              </div>
              <div>
                <Label htmlFor="empresa" className="dark:text-gray-300">Empresa</Label>
                <Input
                  id="empresa"
                  value={formData.empresa}
                  onChange={(e) => setFormData({...formData, empresa: e.target.value})}
                  className="dark:bg-gray-800 dark:border-gray-700"
                />
              </div>
            </div>

            <div className="grid grid-cols-2 gap-4">
              <div>
                <Label htmlFor="email" className="dark:text-gray-300">Email *</Label>
                <Input
                  id="email"
                  type="email"
                  value={formData.email}
                  onChange={(e) => setFormData({...formData, email: e.target.value})}
                  required
                  className="dark:bg-gray-800 dark:border-gray-700"
                />
              </div>
              <div>
                <Label htmlFor="telefono" className="dark:text-gray-300">Teléfono</Label>
                <Input
                  id="telefono"
                  value={formData.telefono}
                  onChange={(e) => setFormData({...formData, telefono: e.target.value})}
                  className="dark:bg-gray-800 dark:border-gray-700"
                />
              </div>
            </div>

            <div>
              <Label htmlFor="notas" className="dark:text-gray-300">Notas Internas</Label>
              <Textarea
                id="notas"
                value={formData.notas_internas}
                onChange={(e) => setFormData({...formData, notas_internas: e.target.value})}
                rows={4}
                className="dark:bg-gray-800 dark:border-gray-700"
              />
            </div>
          </div>

          <DialogFooter>
            <Button type="button" variant="outline" onClick={onClose} disabled={isLoading}>
              Cancelar
            </Button>
            <Button type="submit" disabled={isLoading} className="bg-indigo-600 hover:bg-indigo-700">
              {isLoading ? "Creando..." : "Crear Lead"}
            </Button>
          </DialogFooter>
        </form>
      </DialogContent>
    </Dialog>
  );
}